var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { GlobalContext } from "@/contexts";
import { Center, Link } from "@chakra-ui/react";
import { useContext } from "react";
import { ResponsiveImage } from "@/components/cortex";
export function HeaderLogoWrapper(props) {
    var properties = useContext(GlobalContext).properties;
    return (_jsx(Center, { children: _jsx(Link, __assign({ href: props.href }, { children: _jsx(ResponsiveImage, { src: props.imageUrl, htmlHeight: "50px", htmlWidth: "244px", alt: "".concat(properties.name, " Powered By Indeed") }) })) }));
}
